import { queryGraphQL } from 'common/util/query';
import { node, toQuery } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';

export const FILE_UPLOAD_WRITE_MIMETYPE_INFO = 'FILE_UPLOAD_WRITE_MIMETYPE_INFO';
export const INCOMING_DOCUMENT_CONVERSION_STATUS = 'INCOMING_DOCUMENT_CONVERSION_STATUS';
export const RETRIEVED_ACTIVE_DOCUMENT_CONVERSION_STATUSES = 'RETRIEVED_ACTIVE_DOCUMENT_CONVERSION_STATUSES';
export const ADD_UPLOAD_FAILED_DOCUMENT = 'ADD_UPLOAD_FAILED_DOCUMENT';
export const DIMISS_FAILED_DOCUMENTS_ACCORDION = 'DIMISS_FAILED_DOCUMENTS_ACCORDION';
export const SET_FILES = 'SET_FILES';

export function loadMimeTypes() {
    return dispatch => {
        const query = [
            node('allowedMimeTypes'),
            node('fileExtensionLookup')
        ];

        return queryGraphQL(toQuery(query)).then(response => {
            if (response.error) {
                dispatch(addApplicationMessage('error', 'Failed to load necessary information for uploading files. Please try again later.'));
            } else {
                dispatch(writeMimeTypeInfo(response.data.allowedMimeTypes, response.data.fileExtensionLookup));
            }
        });
    };
}

function writeMimeTypeInfo(allowedMimeTypes, fileExtensionLookup) {
    return {
        type: FILE_UPLOAD_WRITE_MIMETYPE_INFO,
        payload: {
            allowedMimeTypes,
            fileExtensionLookup
        }
    };
}

export function incomingDocumentConversionStatus(documentConversionStatus) {
    return {
        type: INCOMING_DOCUMENT_CONVERSION_STATUS,
        payload: {
            documentConversionStatus
        }
    };
}

export function activeDocumentConversions(documentConversionStatuses) {
    return {
        type: RETRIEVED_ACTIVE_DOCUMENT_CONVERSION_STATUSES,
        payload: {
            documentConversionStatuses
        }
    };
}

export function addUploadFailedDocument(fileName) {
    return {
        type: ADD_UPLOAD_FAILED_DOCUMENT,
        payload: {
            fileName
        }
    };
}

export function dismissFailedDocumentsAccordionAction() {
    return {
        type: DIMISS_FAILED_DOCUMENTS_ACCORDION,
        payload: {}
    };
}